// TYPES
import {HQueryType, RoomDataType, SelectedRoomDataType} from '../redux/types';
import {SmoothBehaviorOptions} from 'smooth-scroll-into-view-if-needed';

import smoothScrollIntoView from './smoothScrollIntoView';

// TYPE GUARDS
import {nonNullable} from '../../../../types/type-guards';

// CONFIG
import {scrollIntoViewOptions as defaultScrollIntoViewOptions} from '../details.config';
import {pushga} from '@ibibo/ga-utils';
import {detailsPageClickEventCategoryName} from '../../../config/ga-config';

export function getCheapestRoomData(roomsData: RoomDataType[]) {
  const dataObj = {
    name: roomsData[0]?.rtn,
    originalRoomPrice: roomsData[0]?.rpl[0]?.pd?.opr,
    roomPrice: roomsData[0]?.rpl[0]?.pd?.spr,
    roomPriceAfterLogin: roomsData[0]?.rpl[0]?.pd?.dspr,
    emiData: {
      emi: roomsData[0]?.rpl[0]?.pd?.emi,
      emiRates: roomsData[0]?.rpl[0]?.pd?.emid,
    },
    tax: roomsData[0]?.rpl[0]?.pd?.tnc,
    amenities: roomsData[0]?.rpl[0]?.am,
    cltxt: roomsData[0]?.rpl[0]?.cltxt,
    cltxtc: roomsData[0]?.rpl[0]?.cltxtc,
    rawRoomData: roomsData[0]?.rpl[0],
    showDiscount: roomsData[0]?.rpl[0]?.pd?.do,
    cbo: roomsData[0]?.rpl[0]?.pd?.cbo
  };
  return dataObj;
}

export function calculateRoomPriceData({
  // staticMinPrice,
  roomsDataFromHermes = [],
  hQuery,
}: {
  // staticMinPrice: number | undefined;
  hQuery: HQueryType;
  roomsDataFromHermes: RoomDataType[];
  // dispatch: Dispatch;
}) {
  // PRICE CALCULATION START
  let roomData: SelectedRoomDataType = {};
  const pricedetQParam = hQuery?.pricedet;

  if (
    nonNullable(pricedetQParam) &&
    Array.isArray(pricedetQParam) &&
    pricedetQParam.length &&
    pricedetQParam.split('-')[1]
  ) {
    roomData.roomPrice = Number(pricedetQParam.split('-')[1]);
  } else {
    // roomData.roomPrice = staticMinPrice;
    roomData.roomPrice = 0;
  }
  // make usable selected room data
  if (roomsDataFromHermes.length) {
    const cheapestRoomData = getCheapestRoomData(roomsDataFromHermes);
    roomData.originalRoomPrice = cheapestRoomData.originalRoomPrice;
    roomData.roomPrice = cheapestRoomData.roomPrice;
    roomData.emiData = cheapestRoomData.emiData;
    roomData.tax = cheapestRoomData.tax;
    roomData.roomPriceAfterLogin = cheapestRoomData.roomPriceAfterLogin;
    roomData.name = cheapestRoomData.name;
    roomData.amenities = cheapestRoomData.amenities;
    roomData.cltxt = cheapestRoomData.cltxt;
    roomData.cltxtc = cheapestRoomData.cltxtc;
    roomData.rawData = cheapestRoomData.rawRoomData;
    roomData.showDiscount = cheapestRoomData.showDiscount;
    roomData.cbo = cheapestRoomData.cbo;
  }

  return roomData;
}

export const scrollIntoView = (node: Element | null, options?: Partial<SmoothBehaviorOptions>) => {
  if (!node) {
    return;
  }

  smoothScrollIntoView(node, {
    ...(defaultScrollIntoViewOptions as SmoothBehaviorOptions),
    ...options,
  });
};

export function timeFormat(timeString) {
  var hourEnd = timeString.indexOf(':');
  var H = +timeString.substr(0, hourEnd);
  var h = H % 12 || 12;
  var ampm = H < 12 || H === 24 ? 'AM' : 'PM';
  timeString = h + timeString.substr(hourEnd, 3) + ' ' + ampm;
  return timeString;
}

export const detailsPageClickGaPush = ({
  event,
  eventCategory = detailsPageClickEventCategoryName,
  eventAction,
  eventLabel,
}: {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
}) => {
  pushga({
    event,
    eventCategory,
    eventAction,
    eventLabel,
  });
};
